(function() {
try {
  // Only run this logic on product detail pages
  var isProductPage = window.location.pathname.indexOf('/products/') !== -1;
  if (!isProductPage) return;

  // Helper: strips a Shopify GraphQL Global ID down to just the numeric ID
  // e.g. "gid://shopify/Product/123456789" -> "123456789"
  function getNonGlobalId(id) {
    if (!id) return "";
    return String(id).split("/").pop();
  }

  // 1. Determine the current product's ID and handle (slug) from the page
  var currentProductId = null;
  if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
    currentProductId = String(window.ShopifyAnalytics.meta.product.id);
  } else if (window.meta && window.meta.product) {
    currentProductId = String(window.meta.product.id);
  } else if (window.tlFreeGiftData && window.tlFreeGiftData.currentProduct) {
    currentProductId = String(window.tlFreeGiftData.currentProduct.id);
  }

  var currentProductIdNorm = currentProductId ? getNonGlobalId(currentProductId) : "";
  var currentProductHandle = window.location.pathname.split('/products/').pop().split('?')[0].split('#')[0].toLowerCase();

  // Collect the collections this product belongs to (used for collection-based gift rules)
  var currentCollections = [];
  if (window.tlFreeGiftData && window.tlFreeGiftData.currentProduct && window.tlFreeGiftData.currentProduct.collections) {
    currentCollections = window.tlFreeGiftData.currentProduct.collections.map(getNonGlobalId);
  }

  // Redirects the visitor to the homepage
  function doRedirect() {
    window.location.href = "/";
  }

  // 2. [FREE GIFT] Check whether the current product matches any configured free-gift rule
  //    (checks both active and inactive rules)
  function checkFreeGiftRedirect(rules) {
    if (!rules || !rules.length) return false;
    return rules.some(function(rule) {
      // Note: rule.active/inactive status is intentionally not checked here
      return rule.listChilds && rule.listChilds.some(function(child) {
        var childProdId = getNonGlobalId(child.product_id);
        var childShopifyId = getNonGlobalId(child.shopify_id);
        // Match by product ID
        if (childProdId === currentProductIdNorm || childShopifyId === currentProductIdNorm) {
          return true;
        }
        // Match by collection membership
        if (currentCollections.length > 0 && currentCollections.indexOf(childShopifyId) !== -1) {
          return true;
        }
        return false;
      });
    });
  }

  // 3. [PROGRESS BAR] Check whether the current product matches any configured
  //    cart-goal / progress-bar milestone gift (checks both active and inactive rules)
  function checkProgressBarRedirect(rules) {
    if (!rules) return false;
    var listRules = [];
    if (Array.isArray(rules)) {
      listRules = rules;
    } else if (typeof rules === 'object') {
      // Convert object-of-rules into an array, using the object key as the rule id
      listRules = Object.entries(rules).map(function(item) {
        return Object.assign({ id: item[0].split("_")[0] }, item[1]);
      });
    }
    return listRules.some(function(rule) {
      // Note: rule.status is intentionally not checked here
      if (!rule.milestones) return false;
      return rule.milestones.some(function(milestone) {
        if (!milestone.gifts) return false;
        var gifts = [];
        if (typeof milestone.gifts === 'string') {
          try { gifts = JSON.parse(milestone.gifts); } catch (e) { return false; }
        } else if (Array.isArray(milestone.gifts)) {
          gifts = milestone.gifts;
        }
        return gifts && gifts.some(function(gift) {
          var giftProdId = getNonGlobalId(gift.id || gift.product_id);
          var giftHandle = gift.handle ? String(gift.handle).toLowerCase() : "";
          // Match by product ID or by handle/slug
          if (giftProdId === currentProductIdNorm || giftHandle === currentProductHandle) {
            return true;
          }
          return false;
        });
      });
    });
  }

  // A. RUN THE PROGRESS BAR CHECK (uses the global variable tlCartGoalRules)
  function runProgressBarCheck() {
    var rules = window.tlCartGoalRules;
    if (rules && checkProgressBarRedirect(rules)) {
      doRedirect();
      return true;
    }
    return false;
  }

  // If the rules aren't loaded yet, poll for them every 100ms (up to 5 seconds)
  if (!runProgressBarCheck()) {
    var checkInterval = setInterval(function() {
      if (window.tlCartGoalRules) {
        clearInterval(checkInterval);
        runProgressBarCheck();
      }
    }, 100);
    setTimeout(function() { clearInterval(checkInterval); }, 5000);
  }

  // B. RUN THE FREE GIFT CHECK
  //    First try reading cached rule data from localStorage, then fall back to an API fetch
  //    to make sure the check is thorough even if local data is stale/missing
  var shopName = window.Shopify && window.Shopify.shop ? window.Shopify.shop : "";
  var storageKey = "tl-free-gift-local-storage-" + shopName;
  var localDataStr = null;
  try { localDataStr = localStorage.getItem(storageKey); } catch (storageErr) {}

  if (localDataStr) {
    try {
      var localData = JSON.parse(localDataStr);
      if (localData && localData.rules && checkFreeGiftRedirect(localData.rules)) {
        doRedirect();
        return;
      }
    } catch (jsonErr) {}
  }

  // Fallback: fetch the free-gift rules from the app's backend proxy endpoint
  var rootPath = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || "/";
  var proxyUrl = rootPath + "apps/salepify/free-gift/basic";
  proxyUrl = proxyUrl.replace(/\/+/g, '/'); // collapse any duplicate slashes in the URL

  fetch(proxyUrl)
    .then(function(res) {
      if (!res.ok) throw new Error("Network response not ok");
      return res.json();
    })
    .then(function(resData) {
      if (resData && resData.success && resData.data && checkFreeGiftRedirect(resData.data)) {
        doRedirect();
      }
    })
    .catch(function(err) {});

} catch (globalErr) {
  // Fail silently — log a warning but don't break the page
  console.warn("Salepify Custom Redirect Error ignored:", globalErr.message);
}
})();